import { isMobile } from 'is-mobile';
import { loadBijster } from './user-proxy';
function hasAccessToBijster() {
    const MODES = ['read', 'readwrite'];
    // @ts-ignore
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user)
        return false;
    const access = user.accessRights;
    if (!access || !Array.isArray(access) || access.length === 0)
        return false;
    const bijsterApp = access.find((item) => item.application === 'bijster');
    return MODES.includes(bijsterApp.access);
}
function hasAccessToBijsterLight() {
    const MODES = ['read', 'readwrite'];
    // @ts-ignore
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user)
        return false;
    const access = user.accessRights;
    if (!access || !Array.isArray(access) || access.length === 0)
        return false;
    const bijsterApp = access.find((item) => item.application === 'bijster-light');
    return MODES.includes(bijsterApp.access);
}
function leaveRequestLink() {
    if (isMobile()) {
        return '../leaverequest-mobile/';
    }
    return '../leaverequest/';
}
function buildBijsterLink() {
    let urlBijstertWithTicket = '';
    if (hasAccessToBijster()) {
        const bijsterUrl = 'https://insights.groups.be/custom/sense/app/c7c7887b-07a6-42c8-8dd3-82a3e7ad07ef/sheet/3192aa0b-2c08-456c-9a65-417a8d2f79ef/state/analysis?qlikTicket=';
        loadBijster()
            .then(response => {
            urlBijstertWithTicket = bijsterUrl + response.Ticket;
        })
            .catch(error => {
            console.error(error);
        });
    }
    return urlBijstertWithTicket;
}
function buildBijsterLightLink() {
    let urlBijstertWithTicket = '';
    if (hasAccessToBijsterLight()) {
        const bijsterLightUrl = 'https://insights.groups.be/custom/sense/app/147d62e2-6f90-4d2d-b927-e4380cce9029/sheet/3192aa0b-2c08-456c-9a65-417a8d2f79ef/state/analysis';
        loadBijster()
            .then(response => {
            urlBijstertWithTicket = bijsterLightUrl + response.Ticket;
        })
            .catch(error => {
            console.error(error);
        });
    }
    return urlBijstertWithTicket;
}
const menuStructure = function (language, token) {
    return {
        groups: [
            {
                id: 'support',
                apps: [
                    {
                        id: 'portalsupport',
                        title: 'Support',
                        url: '../portalsupport/',
                        external: false
                    },
                    {
                        id: 'itask',
                        title: 'Task',
                        url: `../taskv2/Account/Login?lg=${language}&token=${token}&pays=BE`,
                        external: true
                    },
                    {
                        id: 'observatory',
                        title: 'Observatory',
                        url: `../observatory`,
                        external: false
                    }
                ]
            },
            {
                id: 'payrollManagement',
                apps: [
                    {
                        id: 'dimona_web2016',
                        title: 'Dimona',
                        url: `../dimona_v2/login.aspx?lg=${language}&token=${token}`,
                        external: false
                    },
                    {
                        id: 'identity',
                        title: 'Employees',
                        url: '../employees/',
                        external: false
                    },
                    {
                        id: 'ipickup',
                        title: 'Calendar',
                        url: '../ipickup/',
                        external: false
                    },
                    {
                        id: 'ipickupdimona',
                        title: 'Presta Flex',
                        url: '../ipickupdimona/',
                        external: false
                    },
                    {
                        id: 'carfleet',
                        title: 'Car Fleet',
                        url: '../carfleet',
                        external: false
                    },
                    {
                        id: 'portal_citrix',
                        title: 'ASP',
                        url: '../asp',
                        external: false
                    }
                ]
            },
            {
                id: 'reporting',
                apps: [
                    {
                        id: 'ireport',
                        title: 'Salary Report',
                        url: '../ireport/',
                        external: false
                    },
                    {
                        id: 'ireporting',
                        title: 'Reporting',
                        url: `../reporting/ireporting-login2.aspx?lg=${language}&token=${token}&pays=BE`,
                        external: false
                    },
                    {
                        id: 'bijster',
                        title: 'Insights',
                        url: buildBijsterLink(),
                        external: true
                    },
                    {
                        id: 'bijster-light',
                        title: 'Insights Light',
                        url: buildBijsterLightLink(),
                        external: true
                    }
                ]
            },
            {
                id: 'humanRessourcesManagement',
                apps: [
                    {
                        id: 'whoiswho',
                        title: "Who's who",
                        url: '../whoiswho/',
                        external: false
                    },
                    {
                        id: 'inholidays',
                        title: 'Leave Request',
                        url: leaveRequestLink(),
                        external: false
                    },
                    {
                        id: 'hierarchy',
                        title: 'Organigram',
                        url: '../hierarchy/',
                        external: false
                    },
                    {
                        id: 'iadmin',
                        title: 'Access Rights',
                        url: '../iadmin/',
                        external: false
                    },
                    {
                        id: 'election_app',
                        title: 'XY Tool',
                        url: 'https://groups.xytool.be/#/login',
                        external: true
                    },
                    {
                        id: 'election_info',
                        title: 'Extranet',
                        url: 'https://www.groups.be/1_95962.htm',
                        external: true
                    }
                ]
            },
            {
                id: 'documentManagement',
                apps: [
                    {
                        id: 'idocs',
                        title: 'Doc Generator',
                        url: `https://services.groups.be/docgenerator/FormLoginFromAsp.aspx?lg=${language}&token=${token}&pays=BE`,
                        external: true
                    },
                    {
                        id: 'transfer',
                        title: 'File Transfer',
                        url: '../transferbe/',
                        external: false
                    },
                    {
                        id: 'archies',
                        title: 'Archives',
                        url: `../archives/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'onlinedoc',
                        title: 'Online Document',
                        url: language === 'nl'
                            ? 'https://www.groups.be/nl/nuttige-documenten'
                            : 'https://www.groups.be/fr/documents-utiles',
                        external: true
                    },
                    {
                        id: 'idocument',
                        title: 'Documents',
                        url: `../documents/login.aspx?lg=${language}&token=${token}`,
                        external: false
                    }
                ]
            },
            {
                id: 'accountManagement',
                apps: [
                    {
                        id: 'accounts_web',
                        title: 'Accounts',
                        url: '../accountsweb',
                        external: false
                    },
                    {
                        id: 'ventouris',
                        title: 'eLoket',
                        url: 'https://groeps-eloket.ventouris.be/',
                        external: true
                    },
                    {
                        id: 'formalis',
                        title: 'Formalis',
                        url: `https://online.formalis.be/${language}`,
                        external: true
                    }
                ]
            },
            {
                id: 'simulationTools',
                apps: [
                    {
                        id: 'ibrunet',
                        title: 'Salary Sim',
                        url: `../salarysim/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'icar',
                        title: 'Car Sim',
                        url: `../carsim/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'out',
                        title: 'Out Sim',
                        url: `../outsim/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'senior',
                        title: 'Senior Sim',
                        url: `../seniorsim/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'isimul',
                        title: 'Budget Sim',
                        url: `../budgetsim/isimul-login.aspx?lg=${language}&token=${token}&pays=BE`,
                        external: true
                    },
                    {
                        id: 'imobil',
                        title: 'Mobility Sim',
                        url: `https://services.groups.be/mobilitysim/imobil.aspx?lg=${language}`,
                        external: true
                    },
                    {
                        id: 'isimeffect',
                        title: 'Effect Sim',
                        url: `../simeffect/?lg=${language}`,
                        external: false
                    },
                    {
                        id: 'indepsim',
                        title: 'Independent Sim',
                        url: `../independentsim/?lg=${language}`,
                        external: false
                    }
                ]
            }
        ]
    };
};
export default menuStructure;
//# sourceMappingURL=menu-structure.js.map